import styled, { css } from "styled-components";
import { Colors, FInter, FlexBox, Fonts, RectangularButtonHollow } from "@brg/ui";
import { TagItemViewWrapper } from "../../../core/components/bTag/styles";
import { LayoutConst } from 'core/modules';

export const TagsSearchModalWrapper = styled.div.attrs({
  className: "tags-search-modal",
})<{scroll?: boolean}>`
  user-select: none;
  height: calc(100vh - 100px);
  width: 100%;
  overflow-y: ${p => p.scroll ? 'scroll' : 'hidden'};

  &::-webkit-scrollbar {
    height: 1px;
    width: 2px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.app?.backgroundColor === '#FEFEFE' ? `${Colors.geoWhite47}` : `${Colors.geoWhite100}`};
  }

  ${TagItemViewWrapper} {
    display: inline-flex;
  }

  *::-webkit-scrollbar {
    width: 6px; /* ширина scrollbar */
    height: 10px;
  }
  *::-webkit-scrollbar-track {
    background: transparent; /* цвет дорожки */
  }
  *::-webkit-scrollbar-thumb {
    border-radius: 3px; /* закругления плашки */
    background: rgba(0, 0, 0, 0.596);
  }
`;

export const TagsSearchModalContainer = styled(FlexBox).attrs({
  className: "--container",
})<{ isMobileMenu?: boolean }>`
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: hidden;
  width: 1152px;
  margin: 40px auto 0 auto;
  height: 100%;

  @media (max-width: ${LayoutConst.screen.l_12}px) {
    width: 940px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
    margin-top: 6px;
    padding: 0 10px;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;
      right: 0;
      background: ${({ theme }) => `linear-gradient(transparent, ${theme.app.backgroundColor}) 70%`};
      height: 10px;
      z-index: 10;
      pointer-events: none;
    }

    .--results{
      height: calc(100vh - 420px);
    }  
  }
`;

export const TagsSearchInput = styled.input.attrs({ className: "--input" })<{ isMobileInput?: boolean }>`
  ${Fonts.Inter.text};
  color: ${(p) => p.theme.tagSearch.inputColor} !important;
  width: 100%;
  height: 48px;
  background: ${p => p?.isMobileInput ? p?.theme.tagSearch.background : 'transparent'};
  border: none;
  border-bottom: 1px solid ${(p) => p.theme.tagSearch.inputColor};
  outline: none;
  font-size: 15px;
  line-height: 20px;

  padding: 14px 0px 14px 2px;
  

  ::placeholder {
    color: ${(p) => p.theme.tagSearch.inputColor};
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px){
    height: 40px;
    font-size: 13px;
    line-height: 16px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    padding: 15px 16px 13px 0;
    border-bottom: none;
    
    ::placeholder {
      color: ${Colors.galBlack47};
      font-size: 13px;
      line-height: 16px;
    }
  }
`;

export const TagsSearchInputWrapper = styled(FlexBox)<{isCGRAVE?: boolean, isMobileMenu?: boolean}>`
   background: ${({ theme }) => theme.mainSearchBar.bg};
  border-radius: 3px;
  place-items: center;
  height: 48px;
  padding: 0 16px;
  svg {
    display: block;
  }

  input {
    border: none;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 129.412% */
    letter-spacing: -0.34px;
    padding-top: 0;
    padding-bottom: 0;
    -webkit-user-select: all;
    user-select: all;

    &::placeholder {
      color: ${({ theme }) => theme.tags.modal.search.color}
    }

  }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px){
      height: 40px;
      input{
        font-size: 13px;
        line-height: 16px;
      }
    }
  
    @media (max-width: ${LayoutConst.screen.m}px) {
    border-radius: 3px;
    background: ${(p) => p.isCGRAVE ? '#2C2C2B' : p?.theme.tagSearch.background};
    align-items: center;
    border: none;

    width: calc(100%);
    svg {
      width: 16px !important;
      height: 16px !important;
      margin-right: 0;
      * {
        fill: ${(p) => p.theme.navigationBar.search.svg} !important;
      }
    }
  }
`

export const TagsSearchTitle = styled(FInter.SectionTitleSubtitleBoldDiv)`
  font-size: 43px;
  line-height: 51px;
  font-weight: 600;
  letter-spacing: -0.02em;
  :first-letter {
    text-transform: capitalize;

    @media (max-width: ${LayoutConst.screen.m}px) {
      text-transform: none;
    }
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 34px;
    line-height: 41px;
  }
`

export const TagsSelectedTitle = styled(FInter.Text)`
  color: ${p => p?.theme.tags.tagsSearchPlaceholderText};
  height: 34px;
  font-size: 17px;
  line-height: 22px;
  margin-right: 18px !important;

letter-spacing: -0.02em;
  @media (max-width: ${LayoutConst.screen.m}px) {
    height: initial;
    font-size: 13px;
    line-height: 16px;
    margin-bottom: 18px;
  }
`
export const TagsAvailableTitle = styled(FInter.SectionTitleSubtitleBoldDiv)`
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 33px;
    letter-spacing: -0.02em;
  margin-top: 18px;
  margin-bottom: 8px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    margin-top: 0px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 23px;
    line-height: 27px;
    margin-top: 14px;
    margin-bottom: 0;
  }
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    margin-top: 14px;
    font-size: 20px;
    line-height: 25px;
  }
`

export const TagsSearchSelection = styled.div.attrs({
  className: "--selection",
})`
  > * {
    margin-right: 10px;
  }

  .selected-tags-grid {
    max-height: 141px;
    overflow-y: scroll;
    margin-right: 0;

    &::-webkit-scrollbar {
      height: 1px;
      width: 5px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.app?.backgroundColor === '#FEFEFE' ? `${Colors.geoWhite47}` : `${Colors.geoWhite100}`};
    }

    @media (max-width: ${LayoutConst.screen.l_12}px) {
      min-height: 62px;
      max-height: 62px;
    }
  }
`;

export const TagsSearchResults = styled(FlexBox).attrs({
  className: "--results",
})<{ disabledHeight?: boolean, customHeight?: number }>`
  overflow-y: scroll;
  height: ${p => p?.disabledHeight ? ' 100vh' : 'calc(100vh - '+(p?.customHeight || 380)+'px)'};
  overflow-x: hidden;
  position: relative;

    
  ::-webkit-scrollbar {
    width: 6px; /* ширина scrollbar */
    height: 61px;
  }
  ::-webkit-scrollbar-track {
    background: transparent; /* цвет дорожки */
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 3px; /* закругления плашки */
    background: #909090;
    border: 1.55px solid rgba(0, 0, 0, 0); /* имитация марджина */
    background-clip: padding-box; /* имитация марджина */
  }

  @media (max-width: ${LayoutConst.screen.m + 'px'}) {
    height: ${p => p?.customHeight ? 'calc(100vh - '+(p?.customHeight || 170)+'px)' : '100%'};
  }

  @media (max-width: 720px) {
    padding-bottom: 100px;
    height: calc(100vh - 260px);
  }
`;

export const TagsSearchResultsTitle = styled(FInter.TextBoldMagic).attrs({
  className: "--title",
})<{ clr?: string, isCategoryTag?: boolean }>`
  color: ${(p) => p?.clr ? p?.clr : p.theme.tagSearch.subtitleColor};
  opacity: 1;
  position: relative;
  font-size: 30px;
  transition: opacity 0.2s, color 0.5s;
  display: inline-flex;
  line-height: 40px;
  place-items: baseline;
  cursor: auto;

  svg path {
    transition: 0.5s fill;
  }

  &:hover {
    color: ${(p) => p?.clr ? p?.clr : p.theme.tagSearch.subtitleColor} !important;
  }

  ${p => p?.isCategoryTag ? css`
    &:hover {
      color: ${(p) => p.theme.tagSearch.subtitleColorHover} !important;
      svg path {
        fill: ${(p) => p.theme.tagSearch.subtitleColorHover} !important;
      }
    }
  `: null}

  user-select: none;

  @media(max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 25px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 13px;
    line-height: 16px;
    margin-bottom: 12px;
  }
`;

export const TagsSearchResultsContext = styled(FlexBox)<{
  selected?: boolean;
  isGlobalSearch?: boolean;
}>`
  position: relative;
  height: 100%;
  svg {
    transition: all 0.2s;
  }
  :not(:first-child) {
    ${TagsSearchResultsTitle} {
      margin-top: ${p => p.isGlobalSearch ? '0px' : '30px'} !important;
    }
  }
    .__react_component_tooltip {
        opacity: 1 !important;
        border-radius: 6px;
        padding: 2px 8px 4px !important;
        height: auto;
        font-size: 11px;
        line-height: 13px;
        max-width: 360px;
        ::before {
            display: none;
        }
    }
`;

export const TagsShadow = styled.div`
`;

export const MobileTagIconBox = styled.div`
  margin-right: 24px;
`;

export const LangSelectHolder = styled(FlexBox)`
  position: absolute;
  top: 18px;
  width: 100%;
  justify-content: center;
`;


export const CategoryWrapper = styled(FlexBox)<{ isChild?: boolean, isActive?: boolean }>`
  place-items: center;
  border-bottom: 1px solid rgba(231, 231, 231, 1);
  transition: background-color 0.2s;
  cursor: pointer;
  width: 100%;
  padding-right: 16px;
  user-select: none;

  &:hover {
    background-color: #f2f2f2;
    transition: background-color 0.2s;
  }

  .shevron-icon {
    transform: rotate(-180deg);
    transition: transform 0.2s;
  }
    
  ${({ isChild }) => isChild ? css`
    min-height: 46px;
  ` : css`
    min-height: 49px;
  `};

  ${({ isActive }) => isActive && css`
    .shevron-icon {
      transform: rotate(0deg);
      transition: transform 0.2s;
    }
  `};
  svg {
    cursor: pointer;

    &:hover {
      path {
        fill: #151514;
        transition: 0.2s;
      }
    }
  }
`;

export const ModalContextSplitLine = styled.div`
    border: 1px solid #cdcdcd;
    height: 100%;
    width: 0;
`;

export const TabletTitle = styled(FlexBox)`

  line-height: 40px;
  font-size: 30px;
  font-weight: 600;
  color: ${(p) => p.theme.tagSearch.titleColor};
  cursor: pointer;

  svg {
    width: 12px;
    height: 17px;

    path {
      fill: ${(p) => p.theme.tagSearch.titleColor};
    }
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    line-height: 27px;
    font-size: 23px;
  }
`;

export const SubmitButton = styled(RectangularButtonHollow)`
  height: 48px;
  min-height: 32px;
  font-weight: 600 !important;
  background-color: ${({ theme }) => theme.modal.tagModal.buttons.saveButtonBG};
  color: ${({ theme }) => theme.modal.tagModal.buttons.saveButtonColor};
  border-radius: 3px;
  padding: 13px 48px;
  font-family: Inter;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.01em;
  text-align: left;
  width: 185px !important;
  max-width: 185px !important;
  min-width: 185px !important;

  @media(max-width: ${LayoutConst.screen.m}px) {
    height: 40px;
    min-height: 40px;
  }
`;

export const TagsSearchResultsWrapper = styled(FlexBox)<{ shadowColor: string }>`
  position: relative;


  &:before {
    content: '';
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    background: ${({ shadowColor }) => `linear-gradient(${shadowColor}, transparent) 70%`};
    height: 10px;
    z-index: 10;
    pointer-events: none;
  }

  &:after {
    content: '';
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    right: 0;
    background: ${({ shadowColor }) => `linear-gradient(transparent, ${shadowColor}) 70%`};
    height: 10px;
    z-index: 10;
    pointer-events: none;
  }
`;

export const TitleContainer = styled(FlexBox)`
  justify-content: space-between;
  margin-bottom: 32px;

  @media(max-width: ${LayoutConst.screen.l_12}px) {
    margin-bottom: 0px;
  }
`;import styled, { css } from "styled-components";
import { Colors, FInter, FlexBox, Fonts, RectangularButtonHollow } from "@brg/ui";
import { TagItemViewWrapper } from "../../../core/components/bTag/styles";
import { LayoutConst } from 'core/modules';

export const TagsSearchModalWrapper = styled.div.attrs({
  className: "tags-search-modal",
})<{scroll?: boolean}>`
  user-select: none;
  height: calc(100vh - 100px);
  width: 100%;
  overflow-y: ${p => p.scroll ? 'scroll' : 'hidden'};

  &::-webkit-scrollbar {
    height: 1px;
    width: 2px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.app?.backgroundColor === '#FEFEFE' ? `${Colors.geoWhite47}` : `${Colors.geoWhite100}`};
  }

  ${TagItemViewWrapper} {
    display: inline-flex;
  }

  *::-webkit-scrollbar {
    width: 6px; /* ширина scrollbar */
    height: 10px;
  }
  *::-webkit-scrollbar-track {
    background: transparent; /* цвет дорожки */
  }
  *::-webkit-scrollbar-thumb {
    border-radius: 3px; /* закругления плашки */
    background: rgba(0, 0, 0, 0.596);
  }
`;

export const TagsSearchModalContainer = styled(FlexBox).attrs({
  className: "--container",
})<{ isMobileMenu?: boolean }>`
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: hidden;
  width: 1152px;
  margin: 40px auto 0 auto;
  height: 100%;

  @media (max-width: ${LayoutConst.screen.l_12}px) {
    width: 940px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
    margin-top: 6px;
    padding: 0 10px;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;
      right: 0;
      background: ${({ theme }) => `linear-gradient(transparent, ${theme.app.backgroundColor}) 70%`};
      height: 10px;
      z-index: 10;
      pointer-events: none;
    }

    .--results{
      height: calc(100vh - 420px);
    }  
  }
`;

export const TagsSearchInput = styled.input.attrs({ className: "--input" })<{ isMobileInput?: boolean }>`
  ${Fonts.Inter.text};
  color: ${(p) => p.theme.tagSearch.inputColor} !important;
  width: 100%;
  height: 48px;
  background: ${p => p?.isMobileInput ? p?.theme.tagSearch.background : 'transparent'};
  border: none;
  border-bottom: 1px solid ${(p) => p.theme.tagSearch.inputColor};
  outline: none;
  font-size: 15px;
  line-height: 20px;

  padding: 14px 0px 14px 2px;
  

  ::placeholder {
    color: ${(p) => p.theme.tagSearch.inputColor};
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px){
    height: 40px;
    font-size: 13px;
    line-height: 16px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    padding: 15px 16px 13px 0;
    border-bottom: none;
    
    ::placeholder {
      color: ${Colors.galBlack47};
      font-size: 13px;
      line-height: 16px;
    }
  }
`;

export const TagsSearchInputWrapper = styled(FlexBox)<{isCGRAVE?: boolean, isMobileMenu?: boolean}>`
   background: ${({ theme }) => theme.mainSearchBar.bg};
  border-radius: 3px;
  place-items: center;
  height: 48px;
  padding: 0 16px;
  svg {
    display: block;
  }

  input {
    border: none;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 129.412% */
    letter-spacing: -0.34px;
    padding-top: 0;
    padding-bottom: 0;
    -webkit-user-select: all;
    user-select: all;

    &::placeholder {
      color: ${({ theme }) => theme.tags.modal.search.color}
    }

  }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px){
      height: 40px;
      input{
        font-size: 13px;
        line-height: 16px;
      }
    }
  
    @media (max-width: ${LayoutConst.screen.m}px) {
    border-radius: 3px;
    background: ${(p) => p.isCGRAVE ? '#2C2C2B' : p?.theme.tagSearch.background};
    align-items: center;
    border: none;

    width: calc(100%);
    svg {
      width: 16px !important;
      height: 16px !important;
      margin-right: 0;
      * {
        fill: ${(p) => p.theme.navigationBar.search.svg} !important;
      }
    }
  }
`

export const TagsSearchTitle = styled(FInter.SectionTitleSubtitleBoldDiv)`
  font-size: 43px;
  line-height: 51px;
  font-weight: 600;
  letter-spacing: -0.02em;
  :first-letter {
    text-transform: capitalize;

    @media (max-width: ${LayoutConst.screen.m}px) {
      text-transform: none;
    }
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 34px;
    line-height: 41px;
  }
`

export const TagsSelectedTitle = styled(FInter.Text)`
  color: ${p => p?.theme.tags.tagsSearchPlaceholderText};
  height: 34px;
  font-size: 17px;
  line-height: 22px;
  margin-right: 18px !important;

letter-spacing: -0.02em;
  @media (max-width: ${LayoutConst.screen.m}px) {
    height: initial;
    font-size: 13px;
    line-height: 16px;
    margin-bottom: 18px;
  }
`
export const TagsAvailableTitle = styled(FInter.SectionTitleSubtitleBoldDiv)`
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 33px;
    letter-spacing: -0.02em;
  margin-top: 18px;
  margin-bottom: 8px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    margin-top: 0px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 23px;
    line-height: 27px;
    margin-top: 14px;
    margin-bottom: 0;
  }
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    margin-top: 14px;
    font-size: 20px;
    line-height: 25px;
  }
`

export const TagsSearchSelection = styled.div.attrs({
  className: "--selection",
})`
  > * {
    margin-right: 10px;
  }

  .selected-tags-grid {
    max-height: 141px;
    overflow-y: scroll;
    margin-right: 0;

    &::-webkit-scrollbar {
      height: 1px;
      width: 5px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.app?.backgroundColor === '#FEFEFE' ? `${Colors.geoWhite47}` : `${Colors.geoWhite100}`};
    }

    @media (max-width: ${LayoutConst.screen.l_12}px) {
      min-height: 62px;
      max-height: 62px;
    }
  }
`;

export const TagsSearchResults = styled(FlexBox).attrs({
  className: "--results",
})<{ disabledHeight?: boolean, customHeight?: number }>`
  overflow-y: scroll;
  height: ${p => p?.disabledHeight ? ' 100vh' : 'calc(100vh - '+(p?.customHeight || 380)+'px)'};
  overflow-x: hidden;
  position: relative;

    
  ::-webkit-scrollbar {
    width: 6px; /* ширина scrollbar */
    height: 61px;
  }
  ::-webkit-scrollbar-track {
    background: transparent; /* цвет дорожки */
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 3px; /* закругления плашки */
    background: #909090;
    border: 1.55px solid rgba(0, 0, 0, 0); /* имитация марджина */
    background-clip: padding-box; /* имитация марджина */
  }

  @media (max-width: ${LayoutConst.screen.m + 'px'}) {
    height: ${p => p?.customHeight ? 'calc(100vh - '+(p?.customHeight || 170)+'px)' : '100%'};
  }

  @media (max-width: 720px) {
    padding-bottom: 100px;
    height: calc(100vh - 260px);
  }
`;

export const TagsSearchResultsTitle = styled(FInter.TextBoldMagic).attrs({
  className: "--title",
})<{ clr?: string, isCategoryTag?: boolean }>`
  color: ${(p) => p?.clr ? p?.clr : p.theme.tagSearch.subtitleColor};
  opacity: 1;
  position: relative;
  font-size: 30px;
  transition: opacity 0.2s, color 0.5s;
  display: inline-flex;
  line-height: 40px;
  place-items: baseline;
  cursor: auto;

  svg path {
    transition: 0.5s fill;
  }

  &:hover {
    color: ${(p) => p?.clr ? p?.clr : p.theme.tagSearch.subtitleColor} !important;
  }

  ${p => p?.isCategoryTag ? css`
    &:hover {
      color: ${(p) => p.theme.tagSearch.subtitleColorHover} !important;
      svg path {
        fill: ${(p) => p.theme.tagSearch.subtitleColorHover} !important;
      }
    }
  `: null}

  user-select: none;

  @media(max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 25px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 13px;
    line-height: 16px;
    margin-bottom: 12px;
  }
`;

export const TagsSearchResultsContext = styled(FlexBox)<{
  selected?: boolean;
  isGlobalSearch?: boolean;
}>`
  position: relative;
  height: 100%;
  svg {
    transition: all 0.2s;
  }
  :not(:first-child) {
    ${TagsSearchResultsTitle} {
      margin-top: ${p => p.isGlobalSearch ? '0px' : '30px'} !important;
    }
  }
    .__react_component_tooltip {
        opacity: 1 !important;
        border-radius: 6px;
        padding: 2px 8px 4px !important;
        height: auto;
        font-size: 11px;
        line-height: 13px;
        max-width: 360px;
        ::before {
            display: none;
        }
    }
`;

export const TagsShadow = styled.div`
`;

export const MobileTagIconBox = styled.div`
  margin-right: 24px;
`;

export const LangSelectHolder = styled(FlexBox)`
  position: absolute;
  top: 18px;
  width: 100%;
  justify-content: center;
`;


export const CategoryWrapper = styled(FlexBox)<{ isChild?: boolean, isActive?: boolean }>`
  place-items: center;
  border-bottom: 1px solid rgba(231, 231, 231, 1);
  transition: background-color 0.2s;
  cursor: pointer;
  width: 100%;
  padding-right: 16px;
  user-select: none;

  &:hover {
    background-color: #f2f2f2;
    transition: background-color 0.2s;
  }

  .shevron-icon {
    transform: rotate(-180deg);
    transition: transform 0.2s;
  }
    
  ${({ isChild }) => isChild ? css`
    min-height: 46px;
  ` : css`
    min-height: 49px;
  `};

  ${({ isActive }) => isActive && css`
    .shevron-icon {
      transform: rotate(0deg);
      transition: transform 0.2s;
    }
  `};
  svg {
    cursor: pointer;

    &:hover {
      path {
        fill: #151514;
        transition: 0.2s;
      }
    }
  }
`;

export const ModalContextSplitLine = styled.div`
    border: 1px solid #cdcdcd;
    height: 100%;
    width: 0;
`;

export const TabletTitle = styled(FlexBox)`

  line-height: 40px;
  font-size: 30px;
  font-weight: 600;
  color: ${(p) => p.theme.tagSearch.titleColor};
  cursor: pointer;

  svg {
    width: 12px;
    height: 17px;

    path {
      fill: ${(p) => p.theme.tagSearch.titleColor};
    }
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    line-height: 27px;
    font-size: 23px;
  }
`;

export const SubmitButton = styled(RectangularButtonHollow)`
  height: 48px;
  min-height: 32px;
  font-weight: 600 !important;
  background-color: ${({ theme }) => theme.modal.tagModal.buttons.saveButtonBG};
  color: ${({ theme }) => theme.modal.tagModal.buttons.saveButtonColor};
  border-radius: 3px;
  padding: 13px 48px;
  font-family: Inter;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.01em;
  text-align: left;
  width: 185px !important;
  max-width: 185px !important;
  min-width: 185px !important;

  @media(max-width: ${LayoutConst.screen.m}px) {
    height: 40px;
    min-height: 40px;
  }
`;

export const TagsSearchResultsWrapper = styled(FlexBox)<{ shadowColor: string }>`
  position: relative;


  &:before {
    content: '';
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    background: ${({ shadowColor }) => `linear-gradient(${shadowColor}, transparent) 70%`};
    height: 10px;
    z-index: 10;
    pointer-events: none;
  }

  &:after {
    content: '';
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    right: 0;
    background: ${({ shadowColor }) => `linear-gradient(transparent, ${shadowColor}) 70%`};
    height: 10px;
    z-index: 10;
    pointer-events: none;
  }
`;

export const TitleContainer = styled(FlexBox)`
  justify-content: space-between;
  margin-bottom: 32px;

  @media(max-width: ${LayoutConst.screen.l_12}px) {
    margin-bottom: 0px;
  }
`;